/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_R9Inputs */



/**
* | output |
* | --- |
* | "R9 Same position group" |
*
* @param {Rounds_R9Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_r9 = /** @type {((inputs?: Rounds_R9Inputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_R9Inputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("R9 Même groupe de position")
	if (locale === "es") return /** @type {LocalizedString} */ ("R9 Mismo grupo de posición")
	if (locale === "pt") return /** @type {LocalizedString} */ ("R9 Mesmo grupo de posição")
	if (locale === "it") return /** @type {LocalizedString} */ ("R9 Stesso gruppo posizione")
	return /** @type {LocalizedString} */ ("R9 Same position group")
});